import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Vehicles = Loadable({
  loader: () => import("./routes/vehicles"),
  loading: TopBarProgress,
});
const Drivers = Loadable({
  loader: () => import("./routes/drivers"),
  loading: TopBarProgress,
});
const Settings = Loadable({
  loader: () => import("./routes/settings"),
  loading: TopBarProgress,
});
const Leads = Loadable({
  loader: () => import("./routes/leads"),
  loading: TopBarProgress,
});
const Map = Loadable({
  loader: () => import("./routes/map"),
  loading: TopBarProgress,
});

const Cordinator = () => (
  <Switch>
    <Route path="/vehicles">
      <Vehicles />
    </Route>
    <Route path="/settings">
      <Settings />
    </Route>
    <Route path="/drivers">
      <Drivers />
    </Route>
    <Route path="/leads">
      <Leads />
    </Route>
    <Route path="/mapview">
      <Map />
    </Route>
    <Redirect to="/vehicles" />
  </Switch>
);

export default Cordinator;
